var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcbLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 24,
    rx: 2,
    fill: "#FBFAF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 8C28 6.34315 29.3431 5 31 5H35V17C35 18.6569 33.6569 20 32 20H28V8Z",
    fill: "#31BE3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8C20 6.34315 21.3431 5 23 5H27V17C27 18.6569 25.6569 20 24 20H20V8Z",
    fill: "#F00F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C12 6.34315 13.3431 5 15 5H19V17C19 18.6569 17.6569 20 16 20H12V8Z",
    fill: "#069BE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbLight);
export default __webpack_public_path__ + "static/media/jcb-light.3ae6ff27ddf2ff20fa891089383d5a91.svg";
export { ForwardRef as ReactComponent };